import React from 'react';
import { Instagram } from 'lucide-react';
export function Footer() {
  return <footer className="w-full bg-bp-bg border-t border-bp-line py-16 px-6 md:px-20" data-id="element-34" data-mp="3gf96f0gd6eb2">
      <div className="max-w-container mx-auto" data-id="element-35" data-mp="3gh3sii3dgcgq">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-12" data-id="element-36" data-mp="32ovvcp86ejhi">
          {/* Left Column */}
          <div data-id="element-37" data-mp="36qhdaozkhnyk">
            <div className="mb-6" data-id="element-38" data-mp="36pz8v52r43fk">
              <h3 className="font-display text-3xl text-bp-text tracking-wider uppercase mb-2" data-id="element-39" data-mp="3uf0nja26gata">
                BAJO PERFIL
              </h3>
            </div>
            <div className="space-y-1" data-id="element-40" data-mp="387e5ix8d5do">
              <p className="font-body font-light text-bp-text2 text-sm" data-id="element-41" data-mp="3lec9wggp4cgx">
                Street food.
              </p>
              <p className="font-body font-light text-bp-text2 text-sm" data-id="element-42" data-mp="3qcx8kbgauo39">
                Ingredientes reales.
              </p>
              <p className="font-body font-light text-bp-text2 text-sm" data-id="element-43" data-mp="29ydxc2mb78ay">
                Pasto, Colombia.
              </p>
            </div>
          </div>

          {/* Right Column */}
          <div className="flex flex-col justify-end" data-id="element-44" data-mp="3lalgfg6ys7uh">
            <div className="space-y-3" data-id="element-45" data-mp="3gagzjp259b3q">
              <a href="https://instagram.com/bajoperfil.pasto" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-bp-text2 no-underline hover:text-bp-accent transition-colors duration-300" data-id="element-46" data-mp="3gbiliokp7i08">
                <Instagram className="w-5 h-5" data-id="element-47" data-mp="81yxwl8ju251" />
                <span className="font-body font-light text-sm" data-id="element-48" data-mp="80nsyi3daocc">
                  @bajoperfil.pasto
                </span>
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-bp-line pt-6" data-id="element-49" data-mp="huwhkupa1x58">
          <p className="font-body font-light text-bp-line text-xs text-center" data-id="element-50" data-mp="cus0b2gjoydy">
            © BAJO PERFIL 2026
          </p>
        </div>
      </div>
    </footer>;
}